<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <navbar>
      <template v-slot:navbarname>
        <span>Excel Exporter</span>
      </template>
    </navbar>


    <b-card>
      <b-row>
        <b-col cols="12" md="6">
          <b-row>

            <b-col cols="12" md="6">
              <b-form-group label="export">
                <b-form-select @change="onChangeFilter" v-model="filterExcel.filter"
                               :options="filterExcel.itemsSelect"></b-form-select>

                <download-excel
                    v-if="filterExcel.itemsExcel.length"
                    :name="'change name'"
                    :data="filterExcel.itemsExcel">
                  <b-button variant="success">
                    <span>Export to Excel</span>
                  </b-button>
                </download-excel>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <!--END Filter-->


  </div>
</template>

<script>
import Navbar from "../Partials/Navbar";
import Http from '../../Services/HttpService/HttpService'
import Notification from '../../Services/Notification/Nottification'

export default {
  name: "Index",
  components: {Navbar},
  data() {
    return {
      processGroupType: null,
      filterExcel: {
        itemsSelect: [
          {
            text: 'Categories',
            value: 'categories'
          },
          {
            text: 'Sub Categories',
            value: 'sub_categories'
          },
          {
            text: 'Comments',
            value: 'comments'
          },
          {
            text: 'Countries',
            value: 'cities'
          },
          {
            text: 'Contact us',
            value: 'contactus'
          },
          {
            text: 'Grobhandel',
            value: 'customers'
          },
          {
            text: 'Gifts',
            value: 'gifts'
          },
          {
            text: 'Partnerprogrammer',
            value: 'jobs'
          },
          {
            text: 'Maps',
            value: 'maps'
          },
          {
            text: 'Order Address',
            value: 'order_addresses'
          },
          {
            text: 'Order Delivery Address',
            value: 'order_delivery_addresses'
          },
          {
            text: 'Order Logs',
            value: 'order_logs'
          },
          {
            text: 'Order Products',
            value: 'order_product'
          },
          {
            text: 'Orders',
            value: 'orders'
          },
          {
            text: 'Packages',
            value: 'packages'
          },
          {
            text: 'Payments',
            value: 'payments'
          },
          {
            text: 'Product prices',
            value: 'productamounts'
          },
          {
            text: 'Products',
            value: 'products'
          },
          {
            text: 'Sliders',
            value: 'sliders'
          },
          {
            text: 'User address',
            value: 'useraddresses'
          },
          {
            text: 'Users',
            value: 'users'
          },
        ],
        filter: null,
        itemsExcel: []
      },
      usersCount: 0
    }
  },
  methods: {
    onChangeFilter() {
      this.filterExcelDB();
    },
    filterExcelDB() {
      this.$Progress.start();
      this.filterExcel.itemsExcel=[];
      Http.get(Http.apiurlV2() + 'excel/export/' + this.filterExcel.filter)
          .then(response => {
            if (response.data.status_code === Http.ok()) {
              this.$Progress.finish();
              this.filterExcel.itemsExcel = response.data.data;
            } else {
              Notification.error(response.data.message)
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
  }
}
</script>

<style scoped>

</style>